import styled from 'styled-components'
import Card from '@mui/material/Card'

export const ProfileCard = styled(Card)`
  && {
    max-width: 500px;
    width: 100%;
    border: 1px solid #ddd;
    border-radius: 8px;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
    padding: 16px;
  }
`